<template>
  <div class="main_l">
    <div class="topxiang" style="text-align: center;">
      <img src="../assets/gerenzhongxin/geren19.png">
      <span>{{userName}}</span>
      <span>ID:{{loginName}}</span>
    </div>
    <div class="jibenxinxi">
      <figure v-for="(item,index) in jibenxinxis" @click="getindex(index) " v-show="getxianshi(index)"
        :class="{beijngsdtu:index == 0}">
        <img :src="item.img">
        <figcaption :class="{texts:index == 0}">{{item.text}}</figcaption>
        <div class="xiaoxi" v-show="item.xins&&item.xinshu!=0">
          {{item.xinshu}}
        </div>
      </figure>
    </div>
    <!-- 退出登录 -->
    <div class="tuichuden" v-if="duichu == true">
      <div class="annou">
        <h1>退出登录</h1>
        <p>您确定要退出登录吗？</p>
        <dl>
          <dt @click="quxiao">取消</dt>
          <dd @click="quit">确认</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {
        jibenxinxis: [{
            img: require("../assets/gerenzhongxin/geren15.png"),
            text: "基本资料",
            xinshu: "",
            xins: false
          },
          {
            img: require("../assets/gerenzhongxin/geren14.png"),
            text: "我的分数",
            xins: false,
            xinshu: ""
          },
          {
            img: require("../assets/gerenzhongxin/geren13.png"),
            text: "我的学生",
            xins: false,
            xinshu: ""
          },
          {
            img: require("../assets/gerenzhongxin/geren9.png"),
            text: "收藏院校",
            xins: true,
            xinshu: "0"
          },
          {
            img: require("../assets/gerenzhongxin/geren8.png"),
            text: "收藏专业",
            xins: true,
            xinshu: "0"
          },
          {
            img: require("../assets/gerenzhongxin/geren12.png"),
            text: "我的关注",
            xins: true,
            xinshu: "0"
          },
          {
            img: require("../assets/gerenzhongxin/geren11.png"),
            text: "我的选科",
            xins: false,
            xinshu: ""
          },
          {
            img: require("../assets/gerenzhongxin/geren11.png"),
            text: "职业测评",
            xinshu: "0",
            xins: false
          },
          {
            img: require("../assets/gerenzhongxin/geren10.png"),
            text: "分数位次",
            xins: false,
            xinshu: ""
          },

          {
            img: require("../assets/gerenzhongxin/geren7.png"),
            text: "志愿报告单",
            xins: true,
            xinshu: "0"
          },
          {
            img: require("../assets/gerenzhongxin/geren6.png"),
            text: "安全设置",
            xinshu: "0",
            xins: false
          },
          {
            img: require("../assets/gerenzhongxin/geren5.png"),
            text: "退出登录",
            xins: false,
            xinshu: ""
          },

        ],
        duichu: false,
        userInfo: this.$utils.getlocalStorage("userInfo"),
        userName: "",
        loginName: ""
      }
    },


    methods: {
      getData() {
        let userCang = this.$utils.getlocalStorage("userCang");
        let zydNum = this.$utils.getlocalStorage("zydNum");
        if (this.userInfo != null && this.userInfo.userRole !== '2' && this.userInfo.userRole !== '3') {
          this.jibenxinxis[3].xinshu = userCang.college.length
          this.jibenxinxis[4].xinshu = userCang.major.length
          this.jibenxinxis[5].xinshu = userCang.collegescore.length + userCang.majorscore.length
          this.jibenxinxis[9].xinshu = zydNum
        }

      },
      getxianshi(index) {
        let user = this.$utils.getlocalStorage('userInfo')
        console.log(22)
        if (user.userRole == "3" || user.userRole == "2") {
          return index != 6 && index != 1 && index != 0
        } else {
          return index != 6 && index != 2 && index != 8
        }
      },
      getindex(index) {
        switch (index) {
          case 0:
            this.$router.push('/gerenzhongxin')
            break;
          case 1:
            if (this.$utils.getUserInfo(this)) {
              this.$router.push('/grzx_wdfs')
            }
            break;
          case 2:
            this.$router.push('/grzx_wdxs')
            break;
          case 3:
            this.$router.push('/grzx_shouchangxueyuan')
            break;
          case 4:
            this.$router.push('/grzx_chouchangzhuanye')
            break;
          case 5:
            this.$router.push('/grzx_wodeguanzhu')
            break;
          case 6:
            this.$router.push('/grzx_wodexuanke')
            break;
          case 7:
            this.$router.push('/grzx_xinggeceping')
            break;
          case 8:
            this.$router.push('/grzx_scorerank')
            break;
          case 9:
            this.$utils.removelocalStorage("zyd_selectId")
            this.$router.push('/grzx_wodezhiyuan')
            break;
          case 10:
            this.$router.push('/grzx_xougaimima')
            break;
          case 11:
            this.duichu = true
            break;
          case 12:

            break;
          default:
            break;
        }
      },
      // 取消退出
      quxiao() {
        this.duichu = false
      },
      //退出
      quit() {

        let _this = this;
        this.$utils.removelocalStorage("userToken")
        this.$utils.removelocalStorage("memberInfo")
        this.$utils.removelocalStorage("scoreInfo")
        this.$utils.removelocalStorage("userInfo")
        this.$utils.removelocalStorage("userCang")
        this.$utils.removelocalStorage("userGuan")
        this.$utils.removelocalStorage("areaInfo")
        this.$utils.removelocalStorage("TianbaoQueryKey")


        this.$utils.removelocalStorage("ZhiYuancyc");
        this.$utils.removelocalStorage("ZhiYuanbyb");
        this.$utils.removelocalStorage("ZhiYuanwyw");
        this.$utils.removelocalStorage("ZhiYuandyd");
        this.$utils.removelocalStorage("ZhiYuandyd");

        this.$req.signOut({}).then(function(response) {
          _this.$router.push('/home')
        }).catch(function() {
          if (_this.path == '/home') {
            _this.$emit("reloadAll")
          } else {
            _this.$router.push('/home')
          }
        })
      },
    },
    created() {
      if (this.userInfo.userRole == '2' || this.userInfo.userRole == '3') {
        this.userName = "高报师";
        this.loginName = this.$utils.getlocalStorage("memberInfo").name;
      } else {
        this.userName = this.userInfo.userName;
        this.loginName = this.userInfo.loginName;;
      }
      this.getData()
    }


  }
</script>

<style scoped>
  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .jibenxinxi {
    width: 210px;
    height: 700px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  /* 退出登录 */
  .tuichuden {
    z-index: 9;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgb(0 0 0 / 21%);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: rgb(235 232 230);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 2px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    margin-left: 20px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/leftmenu.vue